import { useI18n } from '@i18n/useI18n';
import {
  AlertOption,
  BoxTop,
  CheckItem,
  DropContent,
  DropDown,
  DropSelect,
  DropSpan,
  EmptyScreen,
  NavButton,
  OptionButton,
  Popup,
  PopupBox,
  SortHeader,
  StudentImage,
  StudentOptions,
  TBody,
  THead,
  TableList,
  TooltipStudentOptions,
  TopNav
} from './CounselorList.styled';
import { useEffect, useRef, useState } from 'react';
import { GridCard, SysMsg } from '@components/GridCards/Common.styled';
import StudentThumbnail from '@components/StudentThumbnail';
import { useStore } from '@store/appStore';
import NoteIcon from '@assets/svg/note.svg';
import { breakpoints } from "@styles/tokens";
import RainbowLoader from "@components/Loaders/RainbowLoader";
import fixedNumber from '@utils/fixedNumber';
import styled from "@emotion/styled";
import toTitleCase, { normalizeName } from '@utils/textTools';
import Tooltip from '@components/Tooltips/Tooltip';
import Icon_Excel from "@assets/svg/excel.svg";
import Icon_PDF from "@assets/svg/pdf.svg";
import Icon_Alert_Off from "@assets/svg/alert-off.svg";
import Icon_Alert_On from "@assets/svg/alert-on.svg";
import Icon_Chevron from "@assets/svg/chevron-down.svg";
import db from '@utils/db';
import moment from 'moment';
import { GeneratePdf } from '@utils/pdfTools';
import { ExportStudentExcel } from '@utils/exports/exportStudent';
import Cross_Icon from '@assets/svg/match/missing.svg'
import FilledArrow_Icon from '@assets/svg/filled_arrow.svg'
import Arrow_Icon from "@assets/svg/d-arrow.svg";
import M_Arrow_Icon from "@assets/svg/m-arrow.svg";
import SearchMarvin from "@assets/svg/search_marvin.svg"
import { Attention, TextBubble } from '@components/ScheduleErrorContainer/ScheduleErrorContainer';
import { CenterDiv } from '@components/Pages/ErrorPage/ErrorPage.styled';
import { AttendanceColors, calculatePercentage, ShowabsenceOrAttendance } from '@utils/percentageTools';


interface IProps {
  title: string,
  content: any,
  scroll?: boolean,
  background?: string,
  titleColor?: string,
  extraButtons?: boolean,
  selectStudent: (username, displayname, id?) => void,
  loading?: boolean,
  caseworkers?: any
}

export const CounselorList = (props: IProps) => {
  const { schoolName, client, callNameSetting, settings, setStudentName, setSelectedStudent, setNote, setNoteUserId, systemSettings, whoIsLoggedIn, filterDate, setAlertInfo, alerts, selectedCaseworker, setSelectedCaseworker, caseWorkerEmail, alertInfo } = useStore();
  const [toggle, setToggle] = useState(false);
  const [items, setItems] = useState(null);
  const [scroll, setScroll] = useState(true);
  const i18n = useI18n();
  const [sort, setSort] = useState("A-Z")
  const [mobile, setMobile] = useState(false)
  const [count, setCount] = useState(10)
  const [selectedStudents, setSelectedStudents] = useState([])
  const [downloading, setDownloading] = useState(false)
  const [exportType, setExportType] = useState(1)
  const [show, setShow] = useState(-1)
  const [allStudents, setAllStudents] = useState(false)
  const exportCount = useRef(0)

  useEffect(() => {
    if (window.innerWidth <= breakpoints.mobile) {
      setMobile(true)
    }
  }, [])

  useEffect(() => {
    if (selectedCaseworker === null && (whoIsLoggedIn.firstname || whoIsLoggedIn.lastname)) {
      if (client.client_id === 3 || client.client_id === 17 || (settings.DEMO === "true" || settings.DEMO === true))
        setSelectedCaseworker((whoIsLoggedIn.firstname + " " + whoIsLoggedIn.lastname).trim())
      else {
        setSelectedCaseworker("Alle")
      }
    }
  }, [whoIsLoggedIn])

  useEffect(() => {
    if (!alertInfo.open) getCase()
  }, [client, alertInfo])

  useEffect(() => {
    setItems(props.content);
  }, [props.content]);

  const getCase = async () => {
    let test = await db.GetLUDUS_CaseworkerReportsRecepients(client.UserName)
    let all_users = test && test.length > 0 && test[0].all_users;
    if (allStudents !== all_users) setAllStudents(all_users)
  }

  const handleBackground = (percentage: number) => {
    return AttendanceColors(settings.COLORSETTINGS, percentage)
  }

  let tempItems = []
  if (items) {
    tempItems = [...items]
    tempItems = tempItems?.sort((a, b) => {
      if (sort === "A-Z") {
        if (a.firstname < b.firstname) return -1; else if (a.firstname === b.firstname) return 0; else if (a.firstname > b.firstname) return 1
      }
      else if (sort === "Z-A") {
        if (a.firstname < b.firstname) return 1; else if (a.firstname === b.firstname) return 0; else if (a.firstname > b.firstname) return -1
      }
      else if (sort === "username asc") {
        if (a.username < b.username) return -1; else if (a.username === b.username) return 0; else if (a.username > b.username) return 1
      }
      else if (sort === "username desc") {
        if (a.username < b.username) return 1; else if (a.username === b.username) return 0; else if (a.username > b.username) return -1
      }
      else if (sort === "Percentage desc") {
        if (settings.USE_LESSON_BASED_ABSENCE === 'true') {
          if (a.lessonspercentage < b.lessonspercentage) return 1; else if (a.lessonspercentage === b.lessonspercentage) return 0; else if (a.lessonspercentage > b.lessonspercentage) return -1
        }
        else {
          if (a.secondpercentage < b.secondpercentage) return 1; else if (a.secondpercentage === b.secondpercentage) return 0; else if (a.secondpercentage > b.secondpercentage) return -1
        }
      }
      else if (sort === "Percentage asc") {
        if (settings.USE_LESSON_BASED_ABSENCE === 'true') {
          if (a.lessonspercentage < b.lessonspercentage) return -1; else if (a.lessonspercentage === b.lessonspercentage) return 0; else if (a.lessonspercentage > b.lessonspercentage) return 1
        }
        else {
          if (a.secondpercentage < b.secondpercentage) return -1; else if (a.secondpercentage === b.secondpercentage) return 0; else if (a.secondpercentage > b.secondpercentage) return 1
        }
      }
    })
  }

  const HandleNote = (e: any, student: any) => {
    e.stopPropagation()
    setStudentName(student.firstname + " " + student.lastname)
    setSelectedStudent(student.firstname, student.student_id, false)
    setNoteUserId(student.student_id)
    setNote(true)
  }

  const NoteCount = styled.div<{ swipeView?: boolean, fullDayView?: boolean }>`
    position: absolute;
    top: -4px;
    right: -4px ;
    width: 20px;
    height: 20px!important;
    background:red;
    color:#fff;
    font-size: 12px;
    border-radius:30px;
    display: flex;
    align-items: center!important;
    justify-content: center!important;
  `;

  let allowNotes = systemSettings.find(t => t.APP_Setting_ID === 9)
  const [open, setOpen] = useState(false);

  const showList = (e) => {
    setOpen(false)
    setSelectedStudents([])
    setSelectedCaseworker(e)
  }

  const handleCheckBoxClick = (studentId) => {
    let studentList = JSON.parse(JSON.stringify(selectedStudents))
    if (studentList.includes(studentId)) studentList = studentList.filter(s => s !== studentId)
    else studentList.push(studentId)
    setSelectedStudents(studentList)
  }

  const handleMultiClick = () => {
    let students = tempItems?.filter(item => (selectedCaseworker === "Alle" || item.KontaktPerson === selectedCaseworker)).map((item) => item.username)
    if (selectedStudents.length == students.length) setSelectedStudents([])
    else setSelectedStudents(students)
  }

  const exportExcelStudents = async () => {
    if (selectedStudents && selectedStudents.length > 0) {
      setExportType(2)
      setShow(1)
      let tags = await db.getAllNote_Tags()
      for (let index = 0; index < tags.length; index++) {
        const element = tags[index];
        element.name = i18n.t('tag-' + element.name)
      }

      for (let index = 0; index < selectedStudents.length; index++) {
        const element = selectedStudents[index];
        let student = items.find(i => i.username === element)
        await ExportExcel(student, tags)
        exportCount.current++
      }
      setShow(2)
    }
  }

  const ExportPdf = async () => {
    if (selectedStudents && selectedStudents.length > 0) {
      setExportType(1)
      setShow(1)
      for (let index = 0; index < selectedStudents.length; index++) {
        const element = selectedStudents[index];
        let student = items.find(i => i.username === element)

        let totalAbs = 0;
        let registrations = []

        await db.Student_Stat_GetTotalPercentage(student.username, filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE).then((totalData) => {
          let total = totalData ? totalData[0] : null;
          if (settings.USE_LESSON_BASED_ABSENCE === 'true') {
            totalAbs = Number(total?.lessonspercentage?.toFixed(1));
          } else {
            totalAbs = Number(total?.secondpercentage?.toFixed(1));
          }
        });

        await GeneratePdf(i18n, settings, filterDate, schoolName, student.username, (student.firstname + " " + student.lastname).trim(), ShowabsenceOrAttendance(settings.SHOWPRESENCE ,totalAbs), settings.SHOWPRESENCE)
        exportCount.current++
      }
      setShow(2)
    }
  }

  const ExportExcel = async (student: any, tags: any) => {
    let exportText = { filename: (student.firstname + " " + student.lastname).replaceAll(" ", "_") + "_" + (filterDate.from === null ? "01-01-2020" : moment(filterDate.from).format("DD-MM-YYYY")) + "_" + (filterDate.to === null ? moment().format("DD-MM-YYYY") : moment(filterDate.to).format("DD-MM-YYYY")), tabname: (student.firstname + " " + student.lastname).replaceAll(" ", "_"), col1: i18n.t('exportExcel-col1'), col2: i18n.t('exportExcel-col2'), col3: i18n.t('exportExcel-col3'), col4: i18n.t('exportExcel-col4'), col5: i18n.t('exportExcel-col5'), col6: i18n.t('exportExcel-col6'), col7: i18n.t('exportExcel-col7'), col8: i18n.t('exportExcel-col8'), col9: i18n.t('exportExcel-col9'), skole: schoolName, periode: (filterDate.from === null ? "01-01-2020" : moment(filterDate.from).format("DD-MM-YYYY")) + " " + i18n.t('for') + " " + (filterDate.to === null ? moment().format("DD-MM-YYYY") : moment(filterDate.to).format("DD-MM-YYYY")), tags: tags }

    if (filterDate.from !== null) {
      await ExportStudentExcel(student.username, moment(filterDate.from), moment(filterDate.to), exportText)
    } else {
      await ExportStudentExcel(student.username, moment("2020-01-01"), moment(), exportText)
    }
  }

  const closePopup = () => {
    setShow(-1)
    exportCount.current = 0
  }

  return (
    <GridCard col={4} padding={"0"} overflowHidden={false} heightAuto={true} background={"transparent"} scroll={props.scroll ? items?.length > 5 : false}>
      <TopNav>
        <h2>{toTitleCase(props.title)} {i18n.t('for-two')} {whoIsLoggedIn.firstname} {whoIsLoggedIn.lastname}</h2>

        {client.client_id === 3 || client.client_id === 17 || settings.DEMO === "true" || settings.DEMO === true? <><DropSelect>
          <div onClick={() => setOpen(!open)}>
            <span>{normalizeName(selectedCaseworker, 21)}</span>
            <Icon_Chevron />
          </div>
          <DropDown active={open}>
            <DropContent>
              {
                props.caseworkers.map(c =>
                  <DropSpan key={c} onClick={() => showList(c)} sel={selectedCaseworker === c}>{c === "Alle" ? i18n.t('all') : c}</DropSpan>
                )
              }
            </DropContent>
          </DropDown>
        </DropSelect>

          <Tooltip content={i18n.t('caseworker-enable')}>
            <NavButton disable={selectedStudents.length === 0} onClick={() => setAlertInfo({ open: true, active: alert ? true : false, students: selectedStudents })}>
              <Icon_Alert_Off />
            </NavButton>
          </Tooltip></> : null}

        <Tooltip content={i18n.t('caseworker-export-excel')}>
          <NavButton disable={selectedStudents.length === 0} onClick={exportExcelStudents}>
            <Icon_Excel />
          </NavButton>
        </Tooltip>

        <Tooltip content={i18n.t('caseworker-export-pdf')}>
          <NavButton disable={selectedStudents.length === 0} onClick={ExportPdf}>
            <Icon_PDF />
          </NavButton>
        </Tooltip>

      </TopNav>
      <Popup show={show > 0}>
        <PopupBox>
          <BoxTop>
            <span>{(i18n.t(exportType === 1 ? "caseworker-export-pdf" : "caseworker-export-excel"))}</span>
            <button onClick={show === 2 ? closePopup : null}>
              <Cross_Icon />
            </button>
          </BoxTop>
          <span></span>
          <p>
            {exportCount.current} {i18n.t("of")} {selectedStudents.length} {(exportType === 1 ? "pdf " + i18n.t("files") : "excel " + i18n.t("files"))} {i18n.t("exported")}
          </p>
          <div>
            {show === 2 ? <button onClick={() => closePopup()}>{i18n.t("ok")}</button> : null}
          </div>
        </PopupBox>
      </Popup>


      {items === null || props.loading === true ? <EmptyScreen><RainbowLoader /></EmptyScreen> : items?.length > 0 ? (
        tempItems?.filter(item => selectedCaseworker === "Alle" || item?.KontaktPerson?.trim() === selectedCaseworker.trim()).length > 0 ?
          <TableList>
            <THead>
              <tr>
                <th><CheckItem checked={selectedStudents.length === tempItems?.filter(item => selectedCaseworker === "Alle" || item.KontaktPerson.trim() === selectedCaseworker.trim()).length} onClick={handleMultiClick} /></th>
                <th></th>
                <th>
                  <SortHeader active={sort === "Z-A" || sort === "A-Z"} sort={sort === "Z-A"} onClick={() => setSort(sort === "A-Z" ? "Z-A" : "A-Z")}>
                    {i18n.t('caseworker-header-1')}
                    <FilledArrow_Icon />
                  </SortHeader>
                </th>
                <th>
                  <SortHeader active={sort === "username desc" || sort === "username asc"} sort={sort === "username desc"} onClick={() => setSort(sort === "username asc" ? "username desc" : "username asc")}>
                    {i18n.t('caseworker-header-2')}
                    <FilledArrow_Icon />
                  </SortHeader>
                </th>
                <th>
                  <SortHeader active={sort === "Percentage asc" || sort === "Percentage desc"} sort={sort === "Percentage asc"} onClick={() => setSort(sort === "Percentage desc" ? "Percentage asc" : "Percentage desc")}>
                    {i18n.t(settings.SHOWPRESENCE?'caseworker-header-3-attendance':'caseworker-header-3')}
                    <FilledArrow_Icon />
                  </SortHeader>
                </th>
                <th></th>
              </tr>
            </THead>
            <TBody>
              {tempItems?.filter(item => selectedCaseworker === "Alle" || item.KontaktPerson.trim() === selectedCaseworker.trim()).map((item, i) => {
                return (
                  <tr key={"registration_" + i}>
                    <td><CheckItem checked={selectedStudents.includes(item.username)} onClick={e => handleCheckBoxClick(item.username)} /></td>
                    <td onClick={() => props.selectStudent(item.username, item.firstname + " " + item.lastname, item.student_id)}><StudentImage><StudentThumbnail font={"1em"} name={item.firstname + " " + item.lastname} src={item.username} /></StudentImage></td>
                    <td onClick={() => props.selectStudent(item.username, item.firstname + " " + item.lastname, item.student_id)}>{item.firstname} {item.lastname}</td>
                    <td onClick={() => props.selectStudent(item.username, item.firstname + " " + item.lastname, item.student_id)}>{item.username}</td>
                    <td onClick={() => props.selectStudent(item.username, item.firstname + " " + item.lastname, item.student_id)}>{ShowabsenceOrAttendance(settings.SHOWPRESENCE , settings.USE_LESSON_BASED_ABSENCE === 'true' ? fixedNumber(item.lessonspercentage) : fixedNumber(item.merit ? calculatePercentage(item.duration, item.absenceduration) : item.secondpercentage))}%</td>
                    <td>
                      <StudentOptions>
                        {client.client_id === 3 || client.client_id === 17 || settings.DEMO === "true" || settings.DEMO === true ? <TooltipStudentOptions
                          content={i18n.t(item.activeReport ? "caseworker-alert-on" : "caseworker-alert-off") + i18n.t(callNameSetting).toLowerCase()}
                          placement={"top-center"} offsetY={10}>
                          <AlertOption active={((whoIsLoggedIn.firstname + " " + whoIsLoggedIn.lastname).trim() === selectedCaseworker && allStudents) || item.activeReport}>
                            {((whoIsLoggedIn.firstname + " " + whoIsLoggedIn.lastname).trim() === selectedCaseworker && allStudents) || item.activeReport ? <Icon_Alert_On /> : <Icon_Alert_Off />}
                          </AlertOption>
                        </TooltipStudentOptions> : null}
                        {allowNotes && allowNotes.value.toLowerCase() === "true" ?
                          <TooltipStudentOptions
                            content={i18n.t(item.notePresent ? callNameSetting + "-tooltip-note" : callNameSetting + "-note")}
                            placement={"top-end"} offsetY={10}>
                            <OptionButton active={item.notePresent}
                              onClick={(e) => HandleNote(e, item)}>
                              <NoteIcon />
                              {item.noteUnreadCount > 0 && <NoteCount>{item.noteUnreadCount}</NoteCount>}
                            </OptionButton>
                          </TooltipStudentOptions> : <></>}
                      </StudentOptions>
                    </td>
                  </tr>)
              })
              }
            </TBody>
          </TableList> :
          <EmptyScreen>
            <CenterDiv>
              <TextBubble>
                <Attention> {i18n.t("no-caseworker-" + callNameSetting)} </Attention>
                <Arrow_Icon />
                <M_Arrow_Icon />
              </TextBubble>
              <SearchMarvin />
            </CenterDiv>
          </EmptyScreen>
      ) : (<SysMsg>{i18n.t(callNameSetting + '-no-student-error')}</SysMsg>)}

    </GridCard>
  );
};

export default CounselorList;